import { Close } from '@mui/icons-material';
import { IconButton, IconButtonProps } from '@mui/material';
import React from 'react';

type CloseIconButtonProps = IconButtonProps & {
  htmlColor?: string;
};

const CloseIconButton: React.FC<CloseIconButtonProps> = ({ onClick, htmlColor, ...rest }) => (
  <IconButton
    aria-label="close"
    onClick={onClick}
    sx={{
      position: 'absolute',
      right: 8,
      top: 8,
      zIndex: 1,
      color: htmlColor,
    }}
    {...rest}
  >
    <Close />
  </IconButton>
);

export default CloseIconButton;
